import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom"
export default function Navbars(prop) {
    return (
        <div>
            <nav
                className={`navbar navbar-expand-lg navbar-${prop.mode} bg-${prop.mode} `}>
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/Calculator">
                        {prop.title}
                    </Link>
                    
                    {/* <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button> */}
                     <div
                        className=" navbar-collapse"
                        id="navbarSupportedContent">
                        <div  className="navbar-nav me-auto mb-2 mb-lg-0">
                            
                        <ul className="navbar-nav">
                            <li className="nav-item">

                            <Link 
                                
                                className="nav-link active"
                                aria-current="page"
                                to="/Forms">
                                    Home
                               
                            </Link>
                            </li>
                            <li className="nav-item">

                            <Link 
                               
                                    className="nav-link active"
                                    aria-current="page"
                                    to="/About">
                                    About
                               
                            </Link>
                            </li>
                            <li>
                                <Link
                                    className="nav-link active"
                                    aria-current="page"
                                    to="/Calculator">
                                         Calculator
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="nav-link active"
                                    aria-current="page"
                                    to="/Dictionary">
                                         Dictionary
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="nav-link active"
                                    aria-current="page"
                                    to="/Rock Paper Scissor">
                                         RPS
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="nav-link active"
                                    aria-current="page"
                                    to="/Counter">
                                         Counter
                                </Link>
                            </li>
                        </ul>
                        </div>
                    {/* <form className="d-flex" role="search">
                            <input
                                className="form-control me-2"
                                type="search"
                                placeholder="Search"
                                aria-label="Search"
                            />
                            <button
                                className="btn btn-outline-success"
                                type="submit">
                                Search
                            </button> */}
                    {/* </form> */}
                     </div> 
                    <div className={`form-check form-switch text-${prop.mode === 'light'?'dark':'light'}`}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            onClick={prop.toggleMode}
                            role="switch"
                            id="flexSwitchCheckDefault"
                        />
                        <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckDefault">
                            {prop.text}
                        </label>
                    </div>
                </div>
            </nav>
        </div>
    );
}

Navbars.propTypes = { title: PropTypes.string.isRequired };

Navbars.defaultProps = {
    title: "Hara",
};
